var map = {
	"./gameplay-chainspin-xlarge.webp": [
		53338,
		53338
	],
	"./gameplay-chokwin-xlarge.webp": [
		18868,
		18868
	],
	"./gameplay-gannar-xlarge.webp": [
		26290,
		26290
	],
	"./gameplay-luckykingbet-xlarge.webp": [
		6553,
		6553
	],
	"./gameplay-mars-br-xlarge.webp": [
		28032,
		28032
	],
	"./gameplay-mars-es-xlarge.webp": [
		87242,
		87242
	],
	"./gameplay-mars-mx-xlarge.webp": [
		177,
		177
	],
	"./gameplay-mars-pt-xlarge.webp": [
		82695,
		82695
	],
	"./gameplay-mars-ru-xlarge.webp": [
		64419,
		64419
	],
	"./gameplay-mars-th-xlarge.webp": [
		21135,
		21135
	],
	"./gameplay-mars-xlarge.webp": [
		68481,
		68481
	],
	"./gameplay-novero-xlarge.webp": [
		55251,
		55251
	],
	"./gameplay-rollblock-xlarge.webp": [
		97406,
		97406
	],
	"./gameplay-zenginsin-xlarge.webp": [
		7694,
		7694
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 62859;
module.exports = webpackAsyncContext;